import { Command } from 'commander';
import chalk from 'chalk';
import { performDeviceFlow } from '../services/auth/auth';
import output from '../utils/output-writer';

const login = new Command('login')
  .description('Authenticate with the Wild Moose service')
  .action(async () => {
    try {
      output.log(chalk.red('Initiating login flow...\n'));
      await performDeviceFlow();
      output.info(
        chalk.green('\n✓ Login successful! Access token has been saved.')
      );
    } catch (error) {
      output.error(
        chalk.red('✗ Login failed:'),
        error instanceof Error ? error.message : String(error)
      );
      process.exit(1);
    }
  });

export default login;
